export default __webpack_public_path__ + "static/media/credit_cards@3x.dc12f307.png";